import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", { class: "flex flex-row justify-between items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col space-y-2" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Sticky Board"),
    /*#__PURE__*/_createElementVNode("h2", null, "Retro sounds in the modern age")
  ])
], -1)
const _hoisted_2 = { class: "flex-grow flex flex-col justify-center space-y-4" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "flex md:hidden" }, "Use the buttons below to interact", -1)
const _hoisted_5 = { class: "hidden md:flex" }
const _hoisted_6 = { class: "md:hidden flex flex-row justify-between" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("footer", { class: "text-sm flex flex-col md:flex-row space-y-2 md:space-y-0 md:justify-between" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Not affiliated with Microsoft"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/dgrinbergs/sticky-board",
    target: "_blank",
    class: "underline"
  }, "Github")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "min-h-screen px-6 py-12 md:p-12 flex flex-col",
    tabindex: "0",
    onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.play && _ctx.play(...args)))
  }, [
    _hoisted_1,
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.instructions), 1),
        _createElementVNode("p", {
          class: _normalizeClass([_ctx.status ? 'text-emerald-500' : 'text-red-500'])
        }, " Sticky keys are " + _toDisplayString(_ctx.status ? "on" : "off"), 3)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
        }, "Turn " + _toDisplayString(_ctx.status ? "Off" : "On"), 1),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.beep1 && _ctx.beep1(...args)))
        }, "Beep 1"),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.beep2 && _ctx.beep2(...args)))
        }, "Beep 2")
      ])
    ]),
    _hoisted_7
  ], 32))
}